export const getMessageElavator = {
    getMessageElvatorInstant: function (msg) {
      var message='';
      message =msg.split('K1:').pop().split('S')[0];
      return message
    },
  }